var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Stack, Typography } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '../../common';
export var CopyFromLocationDropdown = function (_a) {
  var locations = _a.locations,
    currentLocationId = _a.currentLocationId,
    onCopy = _a.onCopy,
    onClear = _a.onClear,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = _a.clearDisabled,
    clearDisabled = _c === void 0 ? false : _c;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.copyFromLocation'
  }).t;
  var _d = useState(null),
    selectedId = _d[0],
    setSelectedId = _d[1];
  var formatLocationLabel = function (loc) {
    return "".concat(loc.locationName).concat(loc.city || loc.countryName ? " (".concat([loc.city, loc.countryName].filter(Boolean).join(', '), ")") : '');
  };
  var options = useMemo(function () {
    return locations.filter(function (loc) {
      return loc.id !== currentLocationId;
    }).map(function (loc) {
      return {
        id: loc.id,
        name: formatLocationLabel(loc)
      };
    });
  }, [locations, currentLocationId]);
  var handleChange = useCallback(function (value) {
    if (!value) return;
    onCopy(value);
    setSelectedId(null);
  }, [onCopy]);
  var isDisabled = disabled || options.length === 0;
  var isClearDisabled = disabled || clearDisabled;
  return _jsxs(Stack, __assign({
    direction: "row",
    alignItems: "center",
    spacing: 2,
    sx: {
      mb: 2
    }
  }, {
    children: [_jsx(Typography, __assign({
      noWrap: true
    }, {
      children: t('copyDataFrom', {
        defaultValue: 'Copy data from'
      })
    })), _jsx(Autocomplete, {
      size: "small",
      disabled: isDisabled,
      fullWidth: false,
      sx: {
        minWidth: 240
      },
      options: options,
      value: selectedId,
      getOptionValue: function (o) {
        return o.id;
      },
      getOptionLabel: function (o) {
        return o.name;
      },
      isOptionEqualToValue: function (o, v) {
        return o.id === v.id;
      },
      placeholder: t('selectLocation', {
        defaultValue: 'Select a location'
      }),
      onChange: handleChange
    }), _jsx(Link, __assign({
      component: "button",
      underline: isClearDisabled ? 'none' : 'always',
      onClick: onClear,
      disabled: isClearDisabled,
      sx: __assign({
        whiteSpace: 'nowrap'
      }, isClearDisabled && {
        color: 'text.disabled',
        cursor: 'default'
      }),
      tabIndex: isClearDisabled ? -1 : 0
    }, {
      children: t('clearData', {
        defaultValue: 'Clear data'
      })
    }))]
  }));
};